import React from "react";
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import { array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import trustLogo from "../../../../../assets/images/trust-logo.png";
import FacebookIcon from "../FooterIcons/FacebookIcon";
import TwitterIcon from "../FooterIcons/TwitterIcon";
import Instagram from "../../../atoms/icons/Instagram";
import YoutubeIcon from "../FooterIcons/YoutubeIcon";
import FooterMenuGroup from "../../../molecules/FooterMenuGroup";
import { logoRenderer } from "../../../utils/react-utils";
import { getSocialLinks } from "../../../utils/utils";

import "./trustFooter.m.css";

const TrustFooterBase = ({ trustMenuItems, currentPath }) => {
  const menuItems =
    trustMenuItems && trustMenuItems.length ? trustMenuItems.find(item => item.title === "footer") : null;
  const socialLinks = getSocialLinks("trust");

  return (
    <div styleName="footer-wrapper">
      <div styleName="row-1">
        <div>
          <div styleName="logo-wrapper">
            {logoRenderer(<img src={`${assetify(trustLogo)}`} alt="trust-logo" styleName="trust-logo" />, currentPath)}
          </div>
          {menuItems && menuItems.children && menuItems.children.length > 0 && (
            <FooterMenuGroup links={menuItems.children.slice(0, 8)} />
          )}
        </div>
        <div>
          <ul styleName="communication-details">
            <li>প্রথম আলো ট্রাস্ট</li>
            <li>প্রগতি ইনস্যুরেন্স ভবন, ২০-২১ কারওয়ান বাজার , ঢাকা ১২১৫</li>
            <li>ফোন: ৮১৮০০৮১,৮১৮৫৩০৭-১০</li>
            <li>ইমেইল: trust@prothomalo.com</li>
          </ul>
          <div styleName="social-links">
            <Link href={socialLinks.fbUrl}>
              <FacebookIcon color="#222222" />
            </Link>
            <Link href={socialLinks.twitterUrl}>
              <TwitterIcon color="#222222" />
            </Link>
            <Link href={socialLinks.InstagramUrl}>
              <Instagram color="#222222" />
            </Link>
            <Link href={socialLinks.YouTubeUrl} className="youtube-icon">
              <YoutubeIcon color="#222222" />
            </Link>
          </div>
        </div>
      </div>
      <div styleName="row-2">
        <div>© স্বত্ব প্রথম আলো ট্রাস্ট</div>
        <ul styleName="static-links">
          <li>{"Terms & Condition"}</li>
          <li>Privacy Policy</li>
          <li>About</li>
          <li>Advertise</li>
          <li>Contact Us</li>
        </ul>
        <div styleName="editor">সম্পাদক ও প্রকাশক: মতিউর রহমান</div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    trustMenuItems: get(state, ["qt", "data", "navigationMenu", "trustMenuItems"], []),
    currentPath: get(state, ["currentPathReducer", "currentPath"], null)
  };
}

TrustFooterBase.propTypes = {
  trustMenuItems: array,
  currentPath: string
};

export const TrustFooter = connect(mapStateToProps)(TrustFooterBase);

export default TrustFooter;
